module.exports = __webpack_public_path__ + "img/brightsun.2b015680.png";